import { BaseApiService } from './baseApiService';

/**
 * Service for locale and location-based operations
 */
class LocaleService extends BaseApiService {
  async suggestLocaleFromLocation(): Promise<{
    suggestedCountryCode: string;
    suggestedCountryName: string;
    suggestedCurrency: string;
    suggestedLanguage: string;
    suggestedTimezone: string;
    isCountrySupported: boolean;
    detectedIpAddress: string;
  }> {
    await this.ensureInitialized();
    const response = await this.api.get('/locale/suggest');
    return response.data;
  }
}

export const localeService = new LocaleService();
export default localeService;
